import { Observable } from 'rxjs/Observable';
import { EnvVariables } from '../../app/environment-variables/environment-variables.token';
import { Injectable, Inject } from '@angular/core';
import 'rxjs/add/operator/map';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import { HttpClient, HttpHeaders } from '../../../node_modules/@angular/common/http';

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class AuthProvider {

  constructor(
    public http: HttpClient,
    @Inject(EnvVariables) public envVariables
  ) {
  }

  login(credentials): Observable<any> {
    return this.http.post(`${this.envVariables.apiEndpoint}/authenticate`, credentials)
  }

  verifyToken(token: string) {
    let headers = new HttpHeaders()
    headers.append('Authorization', `Bearer ${token}`)
    if (token) {
      return this.http.get(`${this.envVariables.apiEndpoint}/verify-token`, { headers })
    } else {
      return new EmptyObservable()
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts